import { useTranslation } from "react-i18next";
import { resolveTheme, ForgotPasswordForm } from "@heraion/ui";
import { confirmForgotPassword, forgotPassword } from "./auth/cognito";
import { useThemePalette } from "./theme";

// Montaggio sottile del form condiviso, gemello di WelcomeGate. Risolve il
// tema del web e cabla le due sole cose che il web sa e il form no: le due
// chiamate Cognito. ⛔ Nessuna logica qui dentro: se ne cresce, cresce nel
// componente condiviso, che è quello che monta anche mobile.
//
// ⭐ RW-49: `forgotPassword` e `confirmForgotPassword` esistevano in
// `auth/cognito.ts` da sempre e non le chiamava nessuno. Mancava la porta,
// non l'impianto.
export function ForgotPasswordGate({
  onDone,
  onBack,
}: {
  onDone: (message: string) => void;
  onBack: () => void;
}) {
  const { dark, family } = useThemePalette();
  const theme = resolveTheme(dark, family);
  const { i18n } = useTranslation();

  return (
    <ForgotPasswordForm
      theme={theme}
      // ⛔ Il rigetto passa GREZZO al form, che è l'unico posto in cui un codice
      // Cognito diventa una frase. Prima qui c'era un `new Error(message)` che
      // teneva il testo inglese e buttava via il `code`: la traduzione non
      // aveva più niente su cui scegliere, e la stessa riga stava copiata nel
      // mount mobile. Il form normalizza `{ code, message }` da sé, quindi la
      // trappola del "[object Object]" non torna.
      onRequestCode={(email) => forgotPassword(email)}
      onConfirm={({ email, code, newPassword }) =>
        confirmForgotPassword(email, code, newPassword, i18n.language)
      }
      onDone={onDone}
      onBack={onBack}
    />
  );
}
